import { render, staticRenderFns } from "./AscFullScreenIcon.vue?vue&type=template&id=0dc31c9e&scoped=true&"
import script from "./AscFullScreenIcon.vue?vue&type=script&lang=js&"
export * from "./AscFullScreenIcon.vue?vue&type=script&lang=js&"
import style0 from "./AscFullScreenIcon.vue?vue&type=style&index=0&id=0dc31c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc31c9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
